import * as React from "react";
import { StyledGatsbyImage } from "../../styles";
const BackgroundImage = ({
  children,
  backgroundImage,
  imageStyle
}) => {
  return /* @__PURE__ */ React.createElement("div", {
    style: { display: "grid", backgroundColor: "#E60012" }
  }, /* @__PURE__ */ React.createElement(StyledGatsbyImage, {
    maxHeight: [
      "calc(100vh - 58px)",
      "calc(100vh - 58px)",
      "calc(100vh - 104px)"
    ],
    imgStyle: imageStyle && imageStyle,
    loading: "lazy",
    alt: "",
    image: backgroundImage,
    gridArea: ["1/1"]
  }), /* @__PURE__ */ React.createElement("div", {
    style: {
      gridArea: "1/1",
      position: "relative",
      placeItems: "center",
      display: "grid"
    }
  }, children));
};
export default BackgroundImage;
